import * as React from 'react';

const Context = React.createContext<Record<string, unknown>>({});

export const FeatureFlagsProvider: React.FC<React.PropsWithChildren<{ featureFlags: Record<string, unknown> }>> = ({
  children,
  featureFlags,
}) => {
  return <Context.Provider value={featureFlags}>{children}</Context.Provider>;
};

export const useFeatureFlags = <T extends Record<string, unknown>>(): T => {
  const ctx = React.useContext(Context);
  if (!ctx) {
    throw new Error('useFeatureFlags must be used inside FeatureFlagsProvider.');
  }
  return ctx as T;
};
